import { Profile_User } from "generated/graphql";

export const user = {
  roles: [Profile_User.Simple, Profile_User.Admin],
};

export const admin = {
  roles: [Profile_User.Admin],
};
